const themecolor = {
  businessprimary: '#5678aa',
  businesssecondary: '#343434',
  businessbodybg: '#f8f9fa',
  businessbodycolor: '#212529',
  casualprimary: '#52bba2',
  casualsecondary: '#343434',
  casualbodybg: '#f8f9fa',
  casualbodycolor: '#212529',
};

export default themecolor;
